export const SELECTION_SUCCESS = 'SELECTION_SUCCESS';
export const DONT_WANT_TO_BE_REDIRECTED = 'DONT_WANT_TO_BE_REDIRECTED';
export const WANT_TO_BE_REDIRECTED = 'WANT_TO_BE_REDIRECTED';
